import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
} from './ReactiveState.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from './abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { Rememberkif8023snbmn as Remember } from './Remember.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  set1ugseoes1jrmg as set,
  ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue,
} from './coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function updateOnce($this) {
  var currentRememberedState = $this.pak_1.qah();
  var tmp;
  if (!$this.oak_1) {
    var tmp_0;
    if (!$this.nak_1) {
      tmp_0 = true;
    } else {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
      var tmp_1 = _ReactiveState___get_raw__impl__92ipya(currentRememberedState);
      tmp_0 = !(tmp_1 instanceof InternalReactiveNotReady());
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.pah(currentRememberedState);
  }
}
function startListening($this) {
  var tmp = $this;
  tmp.qak_1 = $this.pak_1.tah(() => {
    var tmp;
    if (!$this.oak_1) {
      $this.pah($this.pak_1.qah());
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  updateOnce($this);
}
function stopListening($this) {
  var tmp0_safe_receiver = $this.qak_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.qak_1 = null;
}
var MutableRememberClass;
function MutableRemember() {
  if (MutableRememberClass === VOID) {
    class $ extends BaseReactive() {
      static rak(stopListeningWhenOverridden, useLastWhileLoading, coroutineContext, deactivationDelay, initialValue) {
        stopListeningWhenOverridden = stopListeningWhenOverridden === VOID ? true : stopListeningWhenOverridden;
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().wac_1 : coroutineContext;
        deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
        var $this = this.gal();
        $this.mak_1 = stopListeningWhenOverridden;
        $this.nak_1 = useLastWhileLoading;
        $this.oak_1 = false;
        $this.pak_1 = Remember().hal(coroutineContext, $this.nak_1, deactivationDelay, initialValue);
        $this.qak_1 = null;
        return $this;
      }
      pah(value) {
        super.pah(value);
      }
      qah() {
        if (!this.oak_1 && this.qak_1 == null) {
          updateOnce(this);
        }
        return super.qah();
      }
      ial() {
        if (!this.oak_1 && this.qak_1 == null) {
          startListening(this);
        }
      }
      jal() {
        if (this.qak_1 == null)
          return Unit_instance;
        stopListening(this);
        if (!this.oak_1 && !this.nak_1) {
          this.pah(Companion_getInstance().mah_1);
        }
      }
      cak(value) {
        if (!this.oak_1) {
          this.oak_1 = true;
          if (this.mak_1) {
            stopListening(this);
          }
        }
        this.pah(_ReactiveState___init__impl__fvdp9b(value));
      }
      f52() {
        if (this.oak_1) {
          this.oak_1 = false;
          if (this.mak_1) {
            startListening(this);
          }
          var currentSharedState = this.pak_1.qah();
          var tmp;
          if (!this.nak_1) {
            tmp = true;
          } else {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(currentSharedState);
            tmp = !(tmp_0 instanceof InternalReactiveNotReady());
          }
          if (tmp) {
            this.pah(currentSharedState);
          }
        }
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    protoOf($).gah = set;
    initMetadataForClass($, 'MutableRemember', VOID, VOID, [ReactiveWithMutableValue(), BaseReactive()], [1]);
    MutableRememberClass = $;
  }
  return MutableRememberClass;
}
function mutableRemember(useLastWhileLoading, coroutineContext, initialValue) {
  useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
  coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().wac_1 : coroutineContext;
  return MutableRemember().rak(true, useLastWhileLoading, coroutineContext, null, initialValue);
}
//region block: exports
export {
  MutableRemember as MutableRememberyv35kz5kmml7,
  mutableRemember as mutableRemember1h6fyyolumj0o,
};
//endregion

//# sourceMappingURL=MutableRemember.mjs.map
